export default "__VITE_PUBLIC_ASSET__c620e5f2__"